<template>
    <div class="yes-no">
        <header>{{ header }}</header>

        <div class="checker">
            <div
                class="yes-option"
                :class="{ active: value }"
                @click="emit(true)"
            ><span></span><p>Да</p></div>

            <div
                :class="{ active: !value }"
                @click="emit(false)"
            ><span></span><p>Нет</p></div>
        </div>

        <slot/>
    </div>
</template>

<script>
export default {
    name: 'WideYesNo',
    props: {
        header: String,
        coins: Number,
        value: Boolean,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    methods: {
        emit(v) {
            this.$emit('change', v);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../styles/rem';
    @import "~@/styles/variables";

    header {
        font-size: rem(16);
        line-height: rem(22);
        margin-bottom: rem(18);
        color: #98A0A9;
    }

    .yes-no {
        p {
            margin-bottom: 0;
            margin-top: 0;
        }
    }

    .checker {
        margin: 0 0 rem(24) 0;
        user-select: none;

        .yes-option {
            margin: 0 0 rem(20) 0;
        }

        > * {
            display: flex;
            align-items: center;
            font-size: .8rem;
            //margin: .4rem 0;

            span {
                width: .8rem;
                height: .8rem;
                margin-right: .4rem;
                cursor: pointer;
                border-radius: 50%;
                border: solid #98A0A9;
                border-width: rem(2);
            }

            &.active {
                color: $color-main-primary;
                font-weight: 600;

                span {
                    border-color: inherit;
                    border-width: rem(5);
                }
            }
        }
    }

    @import "../../../../styles/variables";
    @media (max-width: $vm) {
        .yes-no {
            margin: 0;

            .data-model:last-child {
                margin-bottom: 0;
            }
        }

        header {
            margin-bottom: mrem(16);
            margin-top: mrem(24);
            font-size: mrem(14);
            line-height: mrem(17);
            font-weight: 600;
        }

        .checker {
            margin: 0 0 mrem(24) 0;

            .yes-option {
                margin: 0 0 mrem(16) 0;
            }

            > * {
                font-size: mrem(16);

                span {
                    width: mrem(16);
                    height: mrem(16);
                    margin-right: mrem(12);
                    border-width: mrem(2);
                }

                &.active {
                    span {
                        border-width: mrem(5);
                    }
                }
            }
        }
    }
</style>
